module.exports = __webpack_public_path__ + "images/loading-5a56c1835d.gif";